import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

const BackgroundKeyframe = keyframes`
  0% {
    opacity: 0;
   }
  100% {
    opacity: 0.2;
  }
`;

const HeroTextKeyframe = keyframes`
  0% {
    opacity: 0;
    top: 20px;
   }
  100% {
    opacity: 1;
    top: 0;
  }
`;

const CircleBlurKeyframe = keyframes`
  0% {
    opacity: 0;
   }
  100% {
    opacity: 1;
  }
`;

export const Caption = styled.h1`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 4rem;
  margin: 0;
  text-align: center;
  line-height: 100%;
  max-width: 650px;
  margin-top: 60px;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
  }
`;

export const Description = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily.regular};

  color: rgba(255, 255, 255, 0.75);
  font-size: 1.5rem;
  line-height: 170%;
  text-align: center;
  max-width: 50rem;
  opacity: 0;
  position: relative;
  animation: ${HeroTextKeyframe};
  animation-delay: 0.5s;
  animation-duration: 1000ms;
  animation-fill-mode: forwards;
  font-weight: 400;

  ${mediaQuery.maxWidth.phone} {
    font-size: 0.9rem;
    margin-top: 20px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  overflow-y: visible;
`;

export const CircleBlur = styled.div`
  position: absolute;
  top: calc(100vh - 750px);
  z-index: 5;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 800px;
  filter: blur(45px);
  animation: ${CircleBlurKeyframe};
  animation-duration: 2000ms;
  animation-fill-mode: forwards;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 93vh;
  position: relative;
  overflow: hidden;
  padding: 0 20px;
  ${mediaQuery.maxWidth.phone} {
    min-height: 90vh;
  }
`;

export const SubCaption = styled.p`
  letter-spacing: 0.2em;
  font-size: 10px;
  text-transform: uppercase;
`;

export const ImgWrapper = styled.div`
  font-size: 0;
  position: absolute;
  bottom: 0;
  z-index: 5;
  img {
    height: auto;
    min-width: 900px;
    ${mediaQuery.maxWidth.phone} {
      margin-right: 50px;
    }
    ${mediaQuery.maxWidth.custom(450)} {
      margin-right: 200px;
    }
    ${mediaQuery.maxWidth.custom(400)} {
      margin-right: 190px;
    }
  }
`;

export const TextBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  z-index: 15;
  top: -90px;
  ${mediaQuery.maxWidth.tablet} {
    top: -80px;
  }
  @media screen and (orientation: landscape) and (max-height: 580px) {
    top: 0;
  }
`;

export const Background = styled.div`
  position: absolute;
  animation: ${BackgroundKeyframe};
  animation-duration: 2000ms;
  animation-fill-mode: forwards;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-image: radial-gradient(57.07% 73.75% at 76.64% 21.67%, #4915f8 0%, #ff496b 100%);
  filter: blur(100px);
  transform: matrix(-0.95, 0.3, 0.3, 0.95, 0, 0) translate3d(0, 0, 0);
  pointer-events: none;
  ${mediaQuery.maxWidth.phone} {
    filter: blur(50px);
  }
`;
